export const productDescGeneratorUrl =
  'https://ai.mydukaan.io/api/ai/products/generate-desc';
export const seoGeneratorUrl =
  'https://ai.mydukaan.io/api/ai/products/generate-meta-tags';
